const userAccess = {
  candidate: [
    'EditProfile',
    'Dashboard',
    'RequestHistories',
    'NotDisturbMode',
    'OfferCandidateDetail',
    'UnavailabilityCalendar',
    'DashboardPage',
    'Offers',
    'CandidateEntities',
    'CandidateJoinEntities'
  ],
  manager: [
    'EditProfile',
    'Dashboard',
    'RequestHistories',
    'Users',
    'NewUser',
    'EditUser',
    'NewOffer',
    'EditOffer',
    'EditOfferContract',
    'AdminOffer',
    'Stats',
    'CandidatePlanning',
    'DashboardPage',
    'Offers',
    'UserKit',
    'OfferSendToStaff',
    'OfferContract',
    'Contract',
    'ManagerEntities',
    'OfferForm'
  ],
  admin: [
    'EditProfile',
    'Dashboard',
    'RequestHistories',
    'Users',
    'NewUser',
    'EditUser',
    'NewOffer',
    'EditOffer',
    'OfferForm',
    'EditOfferContract',
    'AdminOffer',
    'Stats',
    'Occupations',
    'Managers',
    'NewManager',
    'Services',
    'TimeCodes',
    'NewTimeCode',
    'EditTimeCode',
    'CandidatePlanning',
    'DashboardPage',
    'Offers',
    'UserKit',
    'OfferSendToStaff',
    'OfferContract',
    'Contract',
    'ManagerEntities'
  ]
}

export default userAccess



// WEBPACK FOOTER //
// ./src/settings/userAccess.js